const regions = ['us', 'eea', 'br', 'sg', 'au', 'tr', 'fr']

export const getRegionPath = (path: string) => {
  const region = regions.find((region) => path.match(new RegExp(`^/${region}`)))
  return region ?? ''
}

export const i18nLanguageToDisplayString = (language: string) => {
  switch (language) {
    case 'da':
      return 'Dansk'
    // case "de":
    //   return "Deutsch"
    case 'en':
      return 'English'
    case 'es':
      return 'Español'
    case 'fr':
      return 'Français'
    case 'hu':
      return 'Magyar'
    case 'id':
      return 'Bahasa Indonesia'
    case 'it':
      return 'Italiano'
    case 'pl':
      return 'Polski'
    case 'pt':
      return 'Português'
    case 'pt-BR':
      return 'Português'
    case 'ro':
      return 'Română'
    case 'ru':
      return 'Pусский'
    case 'tr':
      return 'Türkçe'
    case 'vi':
      return 'Tiếng Việt'
    case 'zh-TW':
      return '繁體中文'
    default:
      return ''
  }
}
